import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./table-component.css";
import viewicon from "../../assets/SVGs/view.svg";
import deleteicon from "../../assets/SVGs/delete.svg";
import shareicon from "../../assets/SVGs/share.svg";
import swal from "sweetalert";
import DEATH_API from "../../apis/death.api";
import Loader from "../../components/styled-components/loader/loader";
import * as Style from "../../newComponents/styledComponents/PersonalInstruction";
import { Modal, Select, Icon } from "antd";
// import copyLink from "../../assets/images/DeathModuleNew/create-link-svgrepo-com.svg";
import copyLink from "../../assets/images/copyIconWhite.svg";
import { setActiveStep } from "../../redux/slices/loginSlice";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";

const { Option } = Select;

const DashboardTableComponent = ({
  headers,
  data,
  theme,
  handleDeleteDocument,
  loading,
  getStoredDocuments,
  filter,
}) => {
  const [shareModal, setShareModal] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [copied, setCopied] = useState(null);
  const [timer, setTimer] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [updateObject, setUpdateObject] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [sortedData, setSortedData] = useState([]);

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    setSortedData(data);
  }, [data]);
  const handelCloseShareModal = () => {
    setShareModal(false);
    setCopied(null);
  };
  const pressDeleteDocument = (selectedDocs) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this ?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          if (selectedDocs && selectedDocs.cmId !== null) {
            swal(
              "Error",
              "You can not Delete this Document this is already linked to module.",
              "error"
            );
            handleButtonClick(selectedDocs);
            return;
          } else {
            await handleDeleteDocument(selectedDocs.id);
          }
        } catch (error) {
          console.log("error while updating User Defined", error);
        }
      }
    });
  };
  const handleShareDocument = async () => {
    const data = updateObject;
    console.log("updateObject", updateObject);
    if (updateObject.fileUrl !== null) {
      try {
        setIsLoading(true);
        let res = await DEATH_API.createSecureLink({
          link: updateObject.fileUrl,
          fileName: updateObject.fileName,
          shareWith: "TESTER",
          time: +timer,
        });
        setIsLoading(false);
        setCopied(res);
        console.log("res share documnet", res);
        let docsType = filter === "Death" ? "death" : "collection";
        await getStoredDocuments(docsType);
        return true;
      } catch (error) {
        console.log(error);
        throw new Error(error);
      }
    } else {
      swal("Error", "You Have No File To Share", "error");
    }
  };
  const goToModule = (docs) => {
    if (!docs) return;
    const routes = {
      "Advance Health": 0,
      "Personal Instructions": 3,
      "Important Documents": 10,
      "Insurance Policies": 10,
    };
    if(["Property","Room","Item"].includes(docs.tag)){
      history.push("/inventory_new");
      return;
    }
    if(docs.tag==="collection" || docs.type && (docs.type).toLowerCase() === "collection" ){
      history.push("/collectibles_new");
      return;
    }
    if (routes[docs.tag] !== undefined) {
      dispatch(setActiveStep(routes[docs.tag]));
      history.push("/protector/death");
    }
  };
  const handleButtonClick = (docs) => {
    swal({
      title: "Error",
      text: "You can not Delete this Document this is already linked to module.",
      icon: "error",
      type: "error",
      buttons: {
        ok: {
          text: "Ok",
          value: "ok",
          visible: true,
        },
        upgrade: {
          text: "Go to Module",
          value: "upgrade",
          visible: true,
        },
      },
    }).then((value) => {
      console.log("Button value clicked:", value); // Debugging line to show the value
      switch (value) {
        case "upgrade":
          console.log("calling upgrade");
          goToModule(docs);
          break;

        case "ok":
          console.log("calling Simple");
          break;
      }
    });
  };

  // const handleSort = (key) => {
  //   setSortConfig((prevConfig) => ({
  //     key,
  //     direction:
  //       prevConfig.key === key && prevConfig.direction === "asc"
  //         ? "desc"
  //         : "asc",
  //   }));
  // };
  const handleSort = (header) => {
    const key =
      header === "Module"
        ? "type"
        : header === "Document"
        ? "fileName"
        : header.toLowerCase();
    const newDirection =
      sortConfig.key === header && sortConfig.direction === "asc"
        ? "desc"
        : "asc";
    const sorted =
      sortedData &&
      [...sortedData].sort((a, b) => {
        const aValue = a[key] || ""; // Fallback to empty string if value is missing
        const bValue = b[key] || "";

        if (newDirection === "asc") {
          return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
        } else {
          return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
        }
      });
    setSortConfig({ key: header, direction: newDirection });
    setSortedData(sorted);
  };

  const renderSortIcon = (key) => {
    // if (sortConfig.key !== key) return null; // No icon if the column is not sorted
    // Return both icons, with the appropriate one being active
    if (sortConfig.key === key) {
      return (
        <>
          {sortConfig.direction === "asc" ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "fit-content",
                gap: "2px",
              }}
            >
              <span style={{ color: "black", fontSize: "8px", height: "8px" }}>
                ▲
              </span>{" "}
              {/* Upward arrow */}
              <span style={{ color: "gray", fontSize: "8px", height: "8px" }}>
                ▼
              </span>{" "}
              {/* Downward arrow (inactive) */}
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "fit-content",
                gap: "2px",
              }}
            >
              <span style={{ color: "gray", fontSize: "8px", height: "8px" }}>
                ▲
              </span>{" "}
              {/* Upward arrow (inactive) */}
              <span style={{ color: "black", fontSize: "8px", height: "8px" }}>
                ▼
              </span>{" "}
              {/* Downward arrow */}
            </div>
          )}
        </>
      );
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "fit-content",
          gap: "2px",
        }}
      >
        <span style={{ color: "gray", fontSize: "8px", height: "8px" }}>▲</span>{" "}
        {/* Upward arrow */}
        <span style={{ color: "gray", fontSize: "8px", height: "8px" }}>
          ▼
        </span>{" "}
        {/* Downward arrow */}
      </div>
    );
  };

  return (
    <div
      style={{
        backgroundColor: theme === "dark" ? "#232323" : "white",
      }}
      className="main-dashboad-table-container"
    >
      {shareModal && (
        <Modal visible={shareModal} footer={null} closable={false} centered>
          <div>
            <Icon
              type="close"
              style={{
                cursor: "pointer",
                fontSize: "20px",
                color: "#2a3da3",
                float: "right",
              }}
              onClick={() => {
                handelCloseShareModal();
              }}
            />
            <h4 style={{ color: "#4d5e80", marginBottom: "10px" }}>
              {" "}
              {copied && copied.preSignedUrl
                ? "Secure Link Created"
                : "Share Document Name Using Secure Link"}
            </h4>

            <div className="">
              <div>
                {copied && copied.preSignedUrl ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Style.Input
                        style={{ width: "70%" }}
                        value={copied && copied.preSignedUrl}
                        disabled={true}
                      ></Style.Input>
                      <Style.SaveButton
                        style={{ width: "20%", height: "42px" }}
                        onClick={() => {
                          navigator.clipboard.writeText(copied.preSignedUrl);
                          console.log("cooppues");
                          handelCloseShareModal();
                          swal("Success", "Copied", "success");
                        }}
                      >
                        <img
                          src={copyLink}
                          alt="copy"
                          height={25}
                          width={30}
                        ></img>
                      </Style.SaveButton>
                    </div>
                    {copied && copied.preSignedUrl && (
                      <Style.WrapperButtons>
                        <Style.CancelButton
                          onClick={() => {
                            handelCloseShareModal();
                          }}
                        >
                          Cancel
                        </Style.CancelButton>
                        <Style.SaveButton
                          onClick={() => {
                            navigator.clipboard.writeText(copied.preSignedUrl);
                            console.log("cooppues");
                            handelCloseShareModal();
                            swal("Success", "Copied", "success");
                          }}
                        >
                          Done
                        </Style.SaveButton>
                      </Style.WrapperButtons>
                    )}
                  </div>
                ) : (
                  <>
                    <div
                      style={{
                        color: "#4d5e80",
                        marginBottom: "10px",
                        fontFamily: "Poppins",
                      }}
                    >
                      {" "}
                      Secure Link becomes inactive (expires) after:
                    </div>
                    <Select
                      showSearch
                      placeholder="-Select-"
                      onChange={(value) => {
                        console.log("value", value);
                        setTimer(value);
                      }}
                    >
                      <Option value="3600">One Hour</Option>
                      <Option value="86400">One Day</Option>
                      <Option value="604800">One Week</Option>
                    </Select>
                  </>
                )}
                {copied && copied.preSignedUrl ? null : (
                  <Style.WrapperButtons>
                    <Style.CancelButton
                      onClick={() => {
                        handelCloseShareModal();
                      }}
                    >
                      Cancel
                    </Style.CancelButton>
                    <Style.SaveButton
                      onClick={() => {
                        handleShareDocument();
                      }}
                    >
                      Create Link
                    </Style.SaveButton>
                  </Style.WrapperButtons>
                )}
              </div>
            </div>
          </div>
          <Loader isLoading={isLoading} />
        </Modal>
      )}
      <div className="table-wrapper">
        <table className="custom-table">
          <thead
            style={{
              backgroundColor: theme === "dark" ? "#232323" : "white",
            }}
          >
            <tr
              style={{
                fontWeight: "700",
              }}
            >
              {headers.map((header, index) => (
                <th
                  style={{
                    fontWeight: "700",
                    color: theme === "dark" ? "#ffffff" : "#232323",
                    backgroundColor: theme === "dark" ? "#232323" : "#ffffff",
                  }}
                  key={index}
                  onClick={() => {
                    if (header !== "Action") {
                      handleSort(header);
                    }
                  }}
                >
                  <span
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "start",
                      gap: "8px",
                    }}
                  >
                    {" "}
                    {header}{" "}
                    {header !== "Action" ? renderSortIcon(header) : null}{" "}
                  </span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody
            style={{
              backgroundColor: theme === "dark" ? "#232323" : "white",
            }}
          >
            {sortedData &&
              sortedData.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  <td
                    style={{
                      color: theme === "light" ? "#232323" : "white",
                    }}
                  >
                    <span title={row.fileName && row.fileName}>
                      {" "}
                      {row.fileName && row.fileName.length > 20
                        ? `${row.fileName.substring(0, 17)}...`
                        : row.fileName || "N/A"}{" "}
                    </span>
                  </td>
                  <td
                    style={{
                      color: theme === "light" ? "#232323" : "white",
                      textTransform: "capitalize",
                    }}
                  >
                    {row.type || "N/A"}
                  </td>
                  <td
                    style={{
                      color: theme === "light" ? "#232323" : "white",
                    }}
                  >
                    <img
                      style={{
                        cursor: "pointer",
                        filter: theme === "dark" ? "invert(1)" : "invert(0)",
                      }}
                      src={shareicon}
                      alt=""
                      onClick={() => {
                        setShareModal(true);
                        setDropdown(false);
                        setUpdateObject(row);
                      }}
                    />
                    <a href={row.fileUrl} target="_blank">
                      <img
                        style={{
                          cursor: "pointer",
                          marginLeft: "20px",
                          filter: theme === "dark" ? "invert(1)" : "invert(0)",
                        }}
                        src={viewicon}
                        alt=""
                      />
                    </a>
                    <img
                      style={{
                        cursor: "pointer",
                        marginLeft: "20px",
                        filter: theme === "dark" ? "invert(1)" : "invert(0)",
                      }}
                      src={deleteicon}
                      alt=""
                      onClick={() => {
                        pressDeleteDocument(row);
                      }}
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DashboardTableComponent;
